import { Box, Button, Container, Paper, Typography } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { QuizContext } from "../Context/QuizContext";
import "./Result.css";
import { useNavigate } from "react-router-dom";

const Result = () => {
  const { quizData } = useContext(QuizContext);

  const { amount, score } = quizData;
  const [name, setName] = useState('')
  const navigate = useNavigate()
  console.log(quizData);


  useEffect(() => {
    const storedName = localStorage.getItem("name");
    if (storedName) {
      setName(storedName);
    }
  }, []);

  const getQuiz = ()=>{
    navigate('/Quiz_home')
  }
  
  return (
    <Container maxWidth="sm" className="winning-animation">
      <Paper
        sx={{
          p: "1rem",
          md: "1rem",
          borderRadius: "10px",
          marginBottom: "1rem",
          height: "100%",
          background: `url('https://media0.giphy.com/media/BHNfhgU63qrks/giphy.gif?cid=ecf05e476gwae5prijqhriqagjeba7vdw9s0uqr7jnjifir3&ep=v1_gifs_search&rid=giphy.gif&ct=g') no-repeat center center fixed`,
          backgroundSize: "cover",
        }}
      >
        <Typography></Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src="https://cdn.pixabay.com/photo/2016/05/25/13/28/trophy-1414791_960_720.png"
            alt="My GIF"
            width="30%"
          />
        </Box>
        <Box textAlign="center" mt={3}>
        <Typography
            variant="h3"
            fontWeight="bold"
            mb={3}
            mt={8}
            color="white"
            fontFamily="Kanit"
          >
            Congrats {name} !!!
          </Typography>
          <Typography
            variant="h3"
            fontWeight="bold"
            mb={3}
            color="white"
            fontFamily="Kanit"
          >
            Final Score : {score}
          </Typography>
          <Typography
            variant="h3"
            fontWeight="bold"
            mb={3}
            color="white"
            fontFamily="Kanit"
          >
            Percentage : {(score / amount) * 100}%
          </Typography>
        </Box>
      </Paper>
      <Box mt={3} mb={5} width="100%" height='20px' >
        <Button fullWidth variant="contained" onClick={getQuiz}>Take Another Quiz</Button>
      </Box>
    </Container>
  );
};

export default Result;
